import { useEffect, useState } from 'react';

/** `true` once `value` has stayed the same for `delayMs`, and `false` from the moment it changes. Work that should wait
 * for the user to stop typing can wait for this. */
export function useHasSettled(value: unknown, delayMs: number): boolean {
  const [settled, setSettled] = useState<{ value: unknown } | null>(null);

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled({ value }), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return settled !== null && Object.is(settled.value, value);
}
